import { render } from "./TvmStructuredSuggestions.vue?vue&type=template&id=28ed9d0c&scoped=true"
import script from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"
export * from "./TvmStructuredSuggestions.vue?vue&type=script&lang=js"

import "./TvmStructuredSuggestions.vue?vue&type=style&index=0&id=28ed9d0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ed9d0c"],['__file',"src/Components/ChatWidget/TvmStructuredSuggestions/TvmStructuredSuggestions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28ed9d0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28ed9d0c', __exports__)) {
    api.reload('28ed9d0c', __exports__)
  }
  
  module.hot.accept("./TvmStructuredSuggestions.vue?vue&type=template&id=28ed9d0c&scoped=true", () => {
    api.rerender('28ed9d0c', render)
  })

}


export default __exports__